import React from 'react'
import { FieldArray } from 'redux-form/immutable';
import RenderScoresTableRow from "./renderScoresTableRow";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

const RenderScoresTable = ({ fields, scoreRecord, criteria, parseStore, classes, parseCriterionFromFormTable
                             ,personHasScoredNewStoreForCriterion, getStoreScoreForCriterionAverageValue}) => {
  return (
    <div className={'table-responsive'}>
      <Table className={classes.table + ' table-sm'}>
        <TableHead>
        <TableRow>
          <TableCell scope={'column'}/>
          {criteria.map(criterion => (<TableCell key={criterion.id}>{criterion.name}</TableCell>))}
        </TableRow>
        </TableHead>
        <TableBody>
        {
          fields.map((store, index) => {
            const iteratedStore = parseStore(fields.get(index));
            return (
              <FieldArray
                key={index}
                name={`${store}.criteria`}
                component={RenderScoresTableRow}
                props={{iteratedStore, parseCriterionFromFormTable, personHasScoredNewStoreForCriterion,
                  getStoreScoreForCriterionAverageValue}}
              />
            )
          })

        }
        </TableBody>
      </Table>
    </div>
  );
};

export default withStyles(styles)(RenderScoresTable);



// WEBPACK FOOTER //
// ./src/components/scoreRecord/renderScoresTable.js